import React, { ReactNode } from "react";
import NextImage from "@/components/shared/NextImage";
import { SOFTWARE_STUDIO_MAIN_DATA } from "@/v2-components/pages/software/constants/software-sudio-data";

const BG = "/images/software/studio/software_studio_main.jpg";
const BG_MOBILE = "/images/software/studio/software_studio_main_mobile.jpg";

export default function StudioMainSection({
  contents,
}: {
  contents: ReactNode;
}) {
  const item = SOFTWARE_STUDIO_MAIN_DATA;

  if (!item) {
    return null;
  }

  return (
    <section className="w-full px-4">
      <div className="mx-auto max-w-[1440px]">
        <article className="x-col h-auto md:flex md:h-[500px] md:flex-row">
          <figure className="flex-1">
            <NextImage
              src={BG}
              alt={"studio-main-img"}
              width={720}
              height={500}
              className="hidden h-full w-full rounded-t-2xl object-cover xs:flex md:rounded-l-2xl md:rounded-r-none"
              quality={100}
            />
            <NextImage
              src={BG_MOBILE}
              alt={"studio-main-mobile-img"}
              width={328}
              height={328}
              className="object-fit block h-full w-full rounded-t-2xl xs:hidden md:rounded-l-2xl md:rounded-r-none"
              quality={100}
            />
          </figure>

          {/* contents section */}
          <div className="flex flex-1 flex-col justify-center rounded-b-2xl bg-coolgray-10 md:rounded-r-2xl md:rounded-bl-none">
            {contents}
          </div>
        </article>
      </div>
    </section>
  );
}
